<form name="paginationform" id="form-pagination">

  @if (collectionSize > 0) {
    <div class="container scohr-pagination">
      <div class="row align-items-center">
        <div id="spacer" class="d-none d-md-inline col-md-3 col-xl-4"></div>
        <div id="page-c-wrapper" style="text-align: center" class="col-6 col-sm-6 col-xl-4">
          <div id="page-container" class="d-inline">
            <a class="btn" min ="1" step="1" (click)="onChange(1)" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57 && event.charCode !=32)"><i class="fa fa-angle-double-left"></i></a>
            <a class="btn" min ="1" step="1" (click)="onChange(page-1)" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57 && event.charCode !=32)"><i class="fa fa-angle-left"></i></a>
            <span class="d-none d-sm-inline">| Page </span>
            <input class="d-inline input-sm w-60" type="number" min ="1" step="1" [(ngModel)]="page" (change)="onChange(page)" name="pageNumber" id="pageNumber" aria-label="Page Number" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57 && event.charCode !=32)">
            <span class="d-none d-sm-inline"> of {{totalRows}} |</span>
            <a class="btn" (click)="onChange(page+1)"><i class="fa fa-angle-right"></i></a>
            <a class="btn" (click)="onChange(totalRows)"><i class="fa fa-angle-double-right"></i></a>
          </div>
        </div>
        <div id="rows-container" class="col-1 col-sm-3 col-md-1 col-xl-2">
          <!--<input id="recordsPerPage" name="recordsPerPage" class="d-inline input-sm" type="number" [(ngModel)]="rows" (change)="rowsChange(rows)" aria-label=">Records per page">-->
          <!--<input id="recordsPerPage" name="recordsPerPage" class="d-inline input-sm" type="number" [(ngModel)]="rows" (change)="rowsChange(rows)" aria-label=">Records per page">-->
          <select class="d-inline input-sm" id="inputSearchType"
            name="searchType" [(ngModel)]="rows" #t
            (change)="rowsChange(rows)" [value]="searchType" style="width:90px">
            <option value=10>10</option>
            <option value=25>25</option>
            <option value=50>50</option>
            <option value=100>100</option>
            <option value=500>500</option>
            <option value=1000>1000</option>
            <option value=5000>5000</option>
          </select>
        </div>
        <div id="count-container" class="col col-sm-3 col-md-2 text-right">
          <span class="d-none d-lg-inline">{{indexStart}} - {{indexEnd}} of</span>
          <span class="d-none d-sm-inline d-lg-none">Total:</span>
          <span class="d-inline d-sm-none">Tot:</span>
          <span>&nbsp;{{collectionSize}}</span>
        </div>
      </div>
    </div>
  }
</form>
